import {
  SET_PREFERENCE,
  RESET_PREFERENCES,
} from '../actions/preferenceActions';

// Client-side personal preferences for the logged-in user. Persisted
// automatically by redux-persist (no whitelist/blacklist in persistConfig),
// so these survive reloads without any backend involvement.
const initPreferencesState = {
  // Re-fetch tables/lists on an interval where supported.
  tablePollingEnabled: true,
  // Show confirmation toasts after preference changes and similar actions.
  showActionToasts: true,
  // Default page to land on after login.
  defaultLandingPath: '/',
};

export default (state = initPreferencesState, action) => {
  switch (action.type) {
    case SET_PREFERENCE:
      return { ...state, [action.key]: action.value };

    case RESET_PREFERENCES:
      return initPreferencesState;

    default:
      return state;
  }
};
